// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".manage-person-button[data-v-de673518]{margin:20px 0 20px 20px}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Customers/Orders/Index.vue"],"names":[],"mappings":"AACA,uCACI,uBAAA","sourcesContent":["\n.manage-person-button {\n    margin: 20px 0 20px 20px\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
